import React, {useEffect, useState} from 'react';
import {Box, Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import MaterialPageItemModule from "../../../../components/UI/modul/MaterialPageItemModule";
import Typography from "@mui/material/Typography";
import ButtonExit from "../../../../components/UI/button/ButtonExit";
import ButtonAdd from "../../../../components/UI/button/ButtonAdd";

const ReplacementSimilarMaterials = ({
                                         open,
                                         setOpen,
                                         currentEditRowData,
                                         setCurrentEditRowData,
                                         replacement,
                                         handleModalAlert,
                                         loading
                                     }) => {
    const [prevData, setPrevData] = useState(currentEditRowData)
    useEffect(() => {
        setPrevData(currentEditRowData)
    }, [open]);

    const onClose = () => {
        setOpen(false);
        setCurrentEditRowData(null)
    };

    const selectMaterial = (material) => {
        setCurrentEditRowData(material)
    }

    return (
        <div>
            <Dialog open={open} PaperProps={{
                style: {
                    minWidth: "1400px",
                }
            }}>
                <DialogTitle textAlign="center">Заменить материал</DialogTitle>
                <DialogContent>
                    <Box sx={{
                        height: "32px",
                        fontSize: "18px",
                        margin: "10px 40px",
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        '& .MuiTypography-root': {
                            fontWeight: (theme) => theme.typography.fontWeight,
                            color: (theme) => theme.palette.text.main,
                            opacity: "0.5",
                        },
                    }}>
                        <Typography component="p">Текущее значение: </Typography>
                        <Typography component="p">{prevData?.articleNumber}</Typography>
                        <Typography component="p">{prevData?.name}</Typography>
                    </Box>
                    <Box sx={{
                        height: "32px",
                        fontSize: "18px",
                        margin: "10px 40px",
                        display: "flex",
                        alignItems: "center",
                        borderBottom: currentEditRowData?.id ? "#3B8BEC 1px solid" : "transparent 1px solid",
                        gap: "10px",
                        '& .MuiTypography-root': {
                            fontWeight: (theme) => theme.typography.fontWeight,
                            color: (theme) => theme.palette.text.main,
                        },
                    }}>
                        <Typography component="p">Новое значение: </Typography>
                        <Typography component="p">{currentEditRowData?.articleNumber}</Typography>
                        <Typography component="p">{currentEditRowData?.name}</Typography>
                    </Box>
                    <Box style={{height: 700}}>
                        <MaterialPageItemModule
                            pageSize={20}
                            selectMaterial={selectMaterial}
                            modal={true}
                            selectMaterialId={currentEditRowData?.id}
                            handleModalAlert={handleModalAlert}
                        />
                    </Box>
                </DialogContent>
                <DialogActions sx={{p: '1.25rem'}}>
                    <ButtonExit text={"Выйти"} onClick={onClose}/>
                    <ButtonAdd loading={loading} text={"Замена"} onClick={replacement}/>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default ReplacementSimilarMaterials;